import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class RoadmapTableCreateRoute extends Route {
  @service store;

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      const submittedOnce = controller.get('submittedOnce');
      if (submittedOnce === false) {
        const model = controller.get('model');
        if (!model.isDestroyed) model.deleteRecord();
      }
    }
  }

  beforeModel() {
    return RSVP.all([
      this.store.findAll('person'),
      this.store.findAll('goal'),
      this.store.findAll('theme'),
    ]);
  }

  model() {
    return this.store.createRecord('initiative', {
      status: 'DRAFT',
    });
  }
}

export default instrumentRoutePerformance(RoadmapTableCreateRoute);
